export default __webpack_public_path__ + "static/media/ptm_bg_2.e9a23678.png";